/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { VariantProductResponse } from '../models/VariantProductResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class VariantProductControllerService {
    /**
     * @param jans
     * @param competitorChainCode
     * @returns VariantProductResponse OK
     * @throws ApiError
     */
    public static getVariantProducts(
        jans: Array<string>,
        competitorChainCode: string,
    ): CancelablePromise<VariantProductResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/variant-product/',
            query: {
                'jans': jans,
                'competitorChainCode': competitorChainCode,
            },
        });
    }
}
